import * as types from './constants';

export default {
    // Set classes
    [types.GET_CLASSES](state, data) {
        state.classes = data;
    },
    // Set classes
    [types.GET_SUBJECTS_CLASSES](state, data) {
        state.subjectsClasses = data;
    },
    // Set excercise filter
    [types.GET_EXERCISE_FILTER](state, data) {
        state.exerciseFilter = data;
    },
    // Set exercise detail
    [types.GET_EXERCISE_DETAIL](state, data) {
        state.exerciseDetail = data;
    },

    [types.GET_QUESTION_EXERCISE](state, data) {
        state.question_exercise = data;
    },

    [types.GET_QUESTION_EXERCISE_INFO](state, data) {
        state.question_exercise_info = data;
    },

    [types.SET_QUESTION_ACTIVITY](state, data) {
        state.question_activity = data;
    },

    [types.OPEN_MATH_FORM](state, data) {
        state.open_math = data;
    },

    [types.SEND_MATH_VAL](state, data) {
        state.math_value = data;
    },

    [types.VALIDATE_QUESTION](state, value) {
        state.validate_question = value;
    },

    [types.CHECK_CORRECT_QUESTION](state, value) {
        state.check_answer = value;
    },

    [types.SET_QUESTION_VALID_DATA](state, value) {
        state.question_valid_data = value;
    },
    // Get All Classes
    [types.GET_ALL_CLASSES](state, data) {
        state.allClasses = data;
    },
    [types.GET_EXERCISE_DETAIL_NUMBER](state, data) {
        state.getExerciseDetailNumber = data;
    },
    [types.GET_PRACTICE_TYPE](state, data) {
        state.getPracticeType = data;
    },
    [types.GET_LIST_PRACTICE_TYPE_BOOK](state, data) {
        state.getLisstPracticeTypeBook = data;
    },
    [types.SET_ACTIVE](state, data) {
        state.getActive = data;
    },

    [types.SET_PACTICE_ACTIVE](state, data) {
        state.practiceActive = data;
    },

    [types.SET_PACTICE_TYPES_DATA](state, data) {
        state.practiceTypes = data;
    },

    [types.SET_EXERCISE_CLASS_CURR](state, data) {
        state.exerciseClassCurr = data;
    },

    [types.SET_QUESTIONS_DATA](state, data) {
        state.questionsExercise = data;
    },

    [types.SET_BOOKINDEX_OF_BOOK](state, data) {
        state.bookIndexOfBook = data;
    },

    [types.SET_PARAM_FILTER_EXAM](state, data) {
        state.paramsFilterExExam = data;
    },

    [types.SET_PARAM_FILTER_EX_OTHER_THEMATIC](state, data) {
        state.paramsFilterExOtherThematic = data;
    },
       // Set ebooks detail
    [types.GET_EBOOKS_DETAIL](state, data) {
        state.ebooksDetail = data;
    },

    [types.SET_PARAM_SEARCH_RELATE_MEDIA](state, value) {
        state.paramSearchRelateMedia = value;
    },

    [types.SET_QUESTION_PREVIEW_INFO](state, value) {
        state.infoQuestionPreview = value;
    },

    [types.SER_CATS_FLAT_EXERCISE](state, value) {
        state.catsFlatForExercise = value;
    },
};